import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { equityMarginDetailModel } from './equityMarginDetail.model';
import { ButtonComponent } from '../../../../button/button.component';
import { FormComponent } from '../../../../form/form.component';
import { ServiceStock } from '../../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { InvestoridComponent } from '../../../../gotx/components/Investorid/Investorid.component';
import { GotxGridComponent } from '../../../../gotx/components/gotx-grid/gotx-grid.component';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';

const customCss: string = '';

@Component({
    selector: 'app-equityMarginDetail',
    templateUrl: './equityMarginDetail.component.html'
})
export class equityMarginDetailComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
    @ViewChild('cstmInvestorID', { static: false }) cstmInvestorID: InvestoridComponent;
    @ViewChild('FieldId_2', { static: false }) FieldId_2: ButtonComponent;
    @ViewChild('btnEquityMarginDetailBack', {static: false}) btnEquityMarginDetailBack: ButtonComponent;
    @ViewChild('gotxGridComp',{ static: false})gotxGridComp: GotxGridComponent;

    @Output() selectedMenu = new EventEmitter<String>();

    skeletonContentLoaded = false;
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.cstmInvestorID.revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new equityMarginDetailModel();
        this.componentCode = 'equityMarginDetail';
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
        this.cstmInvestorID.setReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.btnEquityMarginDetailBack.setFocus(true);
        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'equityMarginDetail';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.additionalInfo['cstmInvestorID_desc'] = this.cstmInvestorID.getFieldInfo();
        return this.additionalInfo;
    }
    getFieldValue() {
        this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.cstmInvestorID.setValue(inputValue['cstmInvestorID'], inputDesc['cstmInvestorID_desc']);
        this.value = new equityMarginDetailModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'equityMarginDetail'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'equityMarginDetail_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('equityMarginDetail_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
            this.cstmInvestorID.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorID = value; });
            this.onFormLoad();
            this.checkForHTabOverFlow();
            this.FieldId_2_click(null);
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.cstmInvestorID.clearError();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.cstmInvestorID.onReset();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new equityMarginDetailModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async FieldId_2_click(event) {
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        // let res ={"respCode":"0","errMsg":"","response":{"shortSellMarginList":[],"deliveryMarginList":[],"intraDayMarginList":[{"symbol":" ","displaySymbol":"ACIFORMULA  ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":1815.0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":null,"totalMargin":null,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":null,"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":"  ","segment":"Delivery","buyTradeQuantity":0,"buyTradeValue":0.0,"sellTradeQuantity":0,"sellTradeValue":0.0,"shortSellTradeQty":0,"margincreditStockSale":0.0,"buyOrderQty":11,"buyOrderValue":-1815.0,"sellOrderQty":0,"sellOrderValue":0.0,"shortSellOrderQty":0,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null},{"symbol":" ","displaySymbol":"ABBANK      ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":121.0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":null,"totalMargin":null,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":null,"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":"  ","segment":"Delivery","buyTradeQuantity":0,"buyTradeValue":0.0,"sellTradeQuantity":0,"sellTradeValue":0.0,"shortSellTradeQty":0,"margincreditStockSale":0.0,"buyOrderQty":11,"buyOrderValue":-121.0,"sellOrderQty":0,"sellOrderValue":0.0,"shortSellOrderQty":0,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null}],"brokerageHeld":null},"sessionResponse":null,"target":"sucess"}
        // var resp = res['response'];
        document.getElementById('errMsgDiv').innerHTML ="";
        if (errorCount == 0) {
            inputMap.clear();
            inputMap.set('Body.marginGroupNo', this.services.dataStore.getData("setmarginGroupList"));
            //console.log("product in margin equity",this.services.dataStore.getData("productID"));
            if(this.services.dataStore.getData("productID")==='EQUITY MARKET'){
            //inputMap.set('Body.product', this.services.dataStore.getData("productID"));
            inputMap.set('Body.product', "EQUITY");
            }else{
             inputMap.set('Body.product', this.services.dataStore.getData("productID"));   
            }
           // inputMap.set('Body.product', "EXUITY");
            inputMap.set('Body.clientid', this.cstmInvestorID.cmbInvestorId.getFieldValue());
            this.services.http.fetchApi('/statements/margin/statement', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == 0) {
                        //this.services.alert.showAlert(2, "Failure", -1);
                        this.gotxGridComp.reloadGrid(res['response'].intraDayMarginList);
                    }
                    else {

                        //this.services.alert.showAlert(1, "Sucess", 2000);
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        if (err['ErrorElementPath'] == 'clientid') {
                            this.cstmInvestorID.cmbInvestorId.setError(err['ErrorDescription']);
                        }
                    }
                    document.getElementById('errMsgDiv').innerHTML =this.transalte('ErrorCodes.SystemDown');
                }
            );
        }
    }
async btnEquityMarginDetailBack_click(event){
    let inputMap = new Map();
    this.services.modal.dismissAll();
    const modalRef = this.services.openModal(gotxModalComponent, 'lg',null, "Buying Power Summary");   
}

    fieldDependencies = {
    }
    transalte(text) {
        return this.services.translate.instant(text);
      }
    /*equity details grid starts*/
    datafields =
        [
            { name: 'displaySymbol', type: 'string' },
            { name: 'exchangeID', type: 'string' },
            { name: 'buyTradeQuantity', type: 'number' },
            { name: 'buyTradeValue', type: 'number' },
            { name: 'sellTradeQuantity', type: 'number' },
            { name: 'sellTradeValue', type: 'number' },
            { name: 'buyOrderQty', type: 'number' },
            { name: 'buyOrderValue', type: 'number' },
            { name: 'sellOrderQty', type: 'number' },
            { name: 'sellOrderValue', type: 'number' },
            { name: 'marginHeld', type: 'number' },
            { name: 'margincreditStockSale', type: 'number' }];

    // rowId = "displaySymbol";
    datatype = "json";
     data = [];
    columns: any[] = [
        { text: this.transalte('EquityMarginDetailGrid.Symbol'), datafield: 'displaySymbol', width: "10%", cellsalign: 'left', align: 'center', columngroup: 'tableHeader'  },
        { text: this.transalte('EquityMarginDetailGrid.Exchange'), datafield: 'exchangeID', width: "10%", cellsalign: 'left', align: 'center' , columngroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'buyTradeQuantity', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'buyOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'buyTradeValue', cellsformat: 'f2' ,width: "13%", cellsalign: 'right', align: 'center', columngroup: 'buyOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'sellTradeQuantity',cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'sellOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'sellTradeValue', cellsformat: 'f2' ,width: "13%", cellsalign: 'right', align: 'center', columngroup: 'sellOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'buyOrderQty', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'yyyy' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'buyOrderValue',cellsformat: 'f2' , width: "13%", cellsalign: 'right', align: 'center', columngroup: 'yyyy' },
        { text:this.transalte( 'EquityMarginDetailGrid.Qty'), datafield: 'sellOrderQty', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'zzzz' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'sellOrderValue',cellsformat: 'f2' , width: "13%", cellsalign: 'right', align: 'center', columngroup: 'zzzz' },
        { text: this.transalte('EquityMarginDetailGrid.BuyingPowerHeld'), datafield: 'marginHeld',cellsformat: 'f2' , width: "17%", cellsalign: 'right', align: 'center' , columngroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.BuyingPoweragainstStockSale'),cellsformat: 'f2' ,datafield: 'margincreditStockSale', width: "22%", cellsalign: 'right', align: 'center',columngroup: 'tableHeader' }

    ];
    columngroups: any[] = [
        { text: this.transalte('EquityMarginDetailGrid.TradingPosition'), align: 'center', name: 'tradingPosition', parentgroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.PendingOrderPosition'), align: 'center', name: 'pendingOrderPosition',parentgroup: 'tableHeader'},
        { text: this.transalte('EquityMarginDetailGrid.Buy'), align: 'center', name: 'buyOpenPosition', parentgroup: 'tradingPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Sell'), align: 'center', name: 'sellOpenPosition', parentgroup: 'tradingPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Buy'), align: 'center', name: 'yyyy', parentgroup: 'pendingOrderPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Sell'), align: 'center', name: 'zzzz', parentgroup: 'pendingOrderPosition' },
        {text: this.transalte('EquityMarginDetailGrid.EquityPositionMargin'), align: 'center', name: 'tableHeader' }

    ];

    /*equity details grid ends*/
    async btnExport_click(event) {
        if (this.gotxGridComp.gotxGrid.getrows().length <= 0) {
            this.services.alert.showAlert(2, "There is No Data to export", -1);
        } else {
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text',this.transalte('EquityMarginDetailGrid.BuyTradeQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('EquityMarginDetailGrid.BuyTradeValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('EquityMarginDetailGrid.SellTradeQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('EquityMarginDetailGrid.SellTradeValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderQty', 'text', this.transalte('EquityMarginDetailGrid.BuyOrderQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderValue', 'text', this.transalte('EquityMarginDetailGrid.BuyOrderValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderQty', 'text', this.transalte('EquityMarginDetailGrid.SellOrderQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderValue', 'text', this.transalte('EquityMarginDetailGrid.SellOrderValue'));
          
            this.gotxGridComp.gotxGrid.exportdata('csv', "Equity_Position_Margin");
            
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderValue', 'text',this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
        }
    }


}